import {yupResolver} from '@hookform/resolvers/yup'
import {FC, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Panel, PanelGroup} from 'react-resizable-panels'
import Swal from 'sweetalert2'
import {useCentral} from '../../../../../hooks/useCentral'
import {TabCentralModel} from '../../../../../models'
import {ShowSnackBar} from '../../../../../util/functions'
import {schemaEmailTemplate} from '../../../../../util/validation'
import {ResizeHandle} from '../../../../hoteleria/components/Layout/Container/ResizeHandle/ResizeHandle'
import {EmailTemplateModel} from '../../../model/emailtemplate.model'
import {
  createEmailTemplate,
  deleteEmailTemplate,
  updateEmailTemplate,
} from '../../../services/emailtemplate.service'
import ActionsContent from '../../componentes/Actions'
import ContainerWrapper from '../../componentes/Container'
import {renderPanelContent} from '../components'

const EmailTemplatePageWrapper: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useCentral()
  const [loading, setLoading] = useState(false)

  const methods = useForm<EmailTemplateModel>({
    resolver: yupResolver(schemaEmailTemplate),
  })
  const {reset} = methods

  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setLoading(true)
        let id = currentTabItem.idToDelete
        try {
          const data = await deleteEmailTemplate(id)
          if (!data.data.error) {
            const obj: TabCentralModel = {
              ...currentTabItem,
              content: {
                ...currentTabItem.content,
                headerPanel: 'table-emailtemplate',
              },
              idToDelete: '',
              loadingTable: true,
            }
            changeCurrentTabItem(obj)
            ShowSnackBar('Se eliminó con éxito')
          } else {
            ShowSnackBar(data.data.messageSystem, 'error')
          }
          setLoading(false)
        } catch (error) {
          setLoading(false)
          ShowSnackBar('Error interno', 'error')
        }

        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const onSubmit = async (data: EmailTemplateModel) => {
    setLoading(true)

    await new Promise((resolve) => setTimeout(resolve, 2000))

    if (currentTabItem.idToEdit) {
      data.id = currentTabItem.idToEdit
      data.mensaje = data.mensaje ? btoa(unescape(encodeURIComponent(data.mensaje))) : ''
      const response = await updateEmailTemplate(data)
      if (!response.data.error) {
        reset()
        const obj: TabCentralModel = {
          ...currentTabItem,
          showPanel: false,
          content: {
            ...currentTabItem.content,
            headerPanel: 'table-emailtemplate',
          },
          idToEdit: '',
          loadingTable: true,
        }
        changeCurrentTabItem(obj)
        ShowSnackBar('Se actualizó el registro correctamente')
      } else {
        ShowSnackBar(response.data.messageSystem, 'error')
      }
    } else {
      const response = await createEmailTemplate(data)
      if (!response.data.error) {
        setLoading(false)
        reset()
        ShowSnackBar('Se creó con éxito')
        const obj: TabCentralModel = {
          ...currentTabItem,
          content: {
            ...currentTabItem.content,
            headerPanel: 'table-emailtemplate',
          },
        }
        changeCurrentTabItem(obj)
      } else {
        setLoading(false)
        ShowSnackBar(response.data.messageSystem, 'error')
      }
    }
    setLoading(false)
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ActionsContent
          deleteClick={handleDelete}
          loading={loading}
          textComponentBack='table-emailtemplate'
          textComponentGo='form-emailtemplate'
        />
        <ContainerWrapper>
          <PanelGroup autoSaveId='example' direction='vertical' style={{height: '100%'}}>
            <Panel
              collapsible={true}
              order={1}
              key={`panel-central-header-${currentTabItem.id}`}
              id={`panel-central-header-${currentTabItem.id}`}
              className={'panel__box'}
            >
              <>{renderPanelContent(currentTabItem.content.headerPanel)}</>
            </Panel>
            <>
              {currentTabItem.showPanel && (
                <>
                  <ResizeHandle />
                  <Panel
                    className={'panel__box'}
                    collapsible={true}
                    defaultSize={50}
                    order={2}
                    key={`panel-central-detail-${currentTabItem.id}`}
                    id={`panel-central-detail-${currentTabItem.id}`}
                  >
                    {renderPanelContent(currentTabItem.content.detailPanel)}
                  </Panel>
                </>
              )}
            </>
          </PanelGroup>
        </ContainerWrapper>
      </form>
    </FormProvider>
  )
}

export default EmailTemplatePageWrapper
